import { useState, useEffect } from 'react';
import { getContactDetails, getContactAttributes } from '../services/Contacts';
import Logger from '../utility/Logger';
import States from '../constants/States';
import Endpoints from '../utility/Endpoints';
import {useAppConfig} from "../providers/AppConfigProvider";

const { agentStateTypes } = States;


const useCurrentContact = () => {
  const { updateEndContactId} = useAppConfig();
  
  const [currentContact, setCurrentContact] = useState(null);
  const [contactSet, setContactSet] = useState(new Set());
 function setContacts(contact){
   if (contact) {
        const contactDetails = {
          ...getContactDetails(contact),
          attributes: getContactAttributes(contact),
        };
        setCurrentContact((contact));
        // setContactSet(prev => new Set(prev.add(contactDetails)));
        setContactSet(prev => {
          const next = new Set(prev);
          let found = Array.from(next).find(e => e.contactId === contact.contactId);
          if(found) {
            return next
          } else {
            return new Set(next.add(contactDetails))
          }
        })
      }
 }
 function deleteContact(contact){
   contact.onDestroy(function(connect) { 
        setCurrentContact(null);
        setContactSet(prev => {
          const next = new Set(prev);
          let found = Array.from(next).find(e => e.contactId === connect.contactId);
          next.delete(found);
          return next;
        });
        updateEndContactId(connect.contactId)

      });
   
 }
  useEffect(() => {
    const contacts = window.connect.contact((contact) => {
      Logger.info(`Checking contact obj ${JSON.stringify(contact)}`);
      
      setContacts(contact);
      deleteContact(contact);

    });

    return () => contacts.unsubscribe();
  }, []);

  useEffect(() => {
    const agents = window.connect.agent((agent) => {
      agent.onStateChange((agentStateChange) => {
        if (
          agentStateChange.oldState === agentStateTypes.AFTER_CALL_WORK
        ) {
          setCurrentContact(null);
          setContactSet(new Set());
        }else if (
          agentStateChange.newState.includes(agentStateTypes.OFFLINE)
        ) {
          window.open(Endpoints.Connect.logout);
          window.location.reload(true);
        }
      });
    });
    return () => agents.unsubscribe();
  }, []);

  return {
    currentContact, 
    contactSet,
    setContacts,
    deleteContact
  };
};

export default useCurrentContact;
